/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import * as types from "./types";

export const state = {
  list: [],
  ticket: {},
  limitOptions: [5, 10, 25],
  totalResources: 0,
  currentPage: 1,
  limit: 5,
  loadingData: true,
  newTicketId: 0,
  messages: [],
  hasNotification: false,
};

export const mutations = {
  [types.SET_TICKETS_LIST](state, list) {
    state.list = list;
  },
  [types.SET_TICKET_DATA](state, ticket) {
    state.ticket = ticket;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.SET_TOTAL_RESOURCES](state, total) {
    state.totalResources = total;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.ADD_NEW_TICKET_TO_LIST](state, newTicket) {
    state.list.unshift(newTicket);
  },
  [types.ADD_NEW_RESOURCE_TO_COUNT](state, newResource) {
    state.totalResources += newResource;
  },
  [types.SET_NEW_TICKET_ID](state, newId) {
    state.newTicketId = newId;
  },
  [types.REMOVE_TICKET_DATA](state) {
    state.ticket = {};
  },
  [types.SET_TICKET_MESSAGES](state, messages) {
    state.messages = messages;
  },
  [types.CLEAN_TICKET_MESSAGES](state) {
    state.messages = [];
  },
  [types.ADD_TO_MESSAGES_LIST](state, data) {
    console.log('🔍 Vuex: Adicionando mensagem:', data);
    console.log('🔍 Vuex: Mensagens atuais:', state.messages.length);
    
    // Verificar se a mensagem já existe (por ID)
    const existingMessage = state.messages.find(msg => msg.id === data.id);
    if (existingMessage) {
      console.log('⚠️ Vuex: Mensagem já existe, ignorando:', data.id);
      return;
    }
    
    state.messages.push(data);
    console.log('✅ Vuex: Mensagem adicionada com sucesso. Total:', state.messages.length);
  },
  [types.ENABLE_TICKETS_NOTIFICATIONS](state) {
    state.hasNotification = true;
  },
  [types.DISABLE_TICKETS_NOTIFICATIONS](state) {
    state.hasNotification = false;
  }
};
